import { Button, Flex, Input } from "@amzn/storm-ui";
import { isEmpty } from "lodash";
import React from "react";
import styled from "styled-components";
import { useStore } from "zustand";

import { FeatureFlagsStore } from "../../store/featureFlags";
import { QueryParam } from "../../utils/permission.utils";

const PaddedDiv = styled.div`
    padding: 5px;
`;
export const SpoofAsUserInput: React.FunctionComponent = () => {
    const [spoofAsUser, setSpoofAsUser] = React.useState<string>("");
    const [supportMode] = useStore(FeatureFlagsStore, (state) => [
        state.supportMode,
    ]);
    const handleChange = (e) => {
        setSpoofAsUser(e.target.value);
    };

    const handleSpoofAsUser = () => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set(QueryParam.SPOOF_AS_USER, spoofAsUser);
        window.location.search = searchParams.toString();
    };

    if (!supportMode) {
        return null;
    }

    return (
        <PaddedDiv>
            <Flex direction="row">
                <div style={{ paddingRight: "5px" }}>
                    <Input
                        data-testid="spoof-as-user"
                        id="input-example"
                        placeholder="Spoof as user alias"
                        onChange={handleChange}
                        value={spoofAsUser}
                    />
                </div>
                <Button
                    variant="primary"
                    disabled={isEmpty(spoofAsUser)}
                    onClick={handleSpoofAsUser}
                    data-testid="set-spoof-as-user"
                >
                    Spoof as user
                </Button>
            </Flex>
        </PaddedDiv>
    );
};
